// extracted by mini-css-extract-plugin
export default {"order":"order-details_order__8ycrs","order_color":"order-details_order_color__ftRSF"};